
<template>
    <div id="changePwd">
        <div id="webcamList" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:20px;">
            <!-- <div class="content-item">
                <input type="text" :value="playAddr" placeholder="请输入播放地址" @change="pwdEvent($event, 'playAddr')"/>
            </div> -->
            
            <div class="content-item" v-for="(item, index) in webcamList" :key="index">
                <span style="width:120px;margin-right:20px;" v-if="item.deviceName != '' && item.deviceName != null">{{item.deviceName}}</span>
                <span style="width:120px;margin-right:20px;" v-else>{{item.webcamSerial}}</span>
                <input type="text" :value="item.decodeH5Url" placeholder="请输入播放地址" @change="controlClick($event, index)"/>
            </div>
            
        </div>
        <div class="confirmBtn" @click="confirmEvent()">确&nbsp;&nbsp;定</div>

        <div class="fun-tip" :style="{display:tipdisplay}">
            <span style="color:#d3d6dd;">{{tipText}}</span>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            // playAddr:'',
            webcamList: [],
            tipdisplay: "none",
            tipText: '',
        }
    },
    components: {

    },
    mounted() {
        var globalData = this.$store.state.globalData;
        if(globalData.webcamList == null || globalData.webcamList.length <= 0) {
            return;
        }
        this.webcamList = globalData.webcamList;

        // let addr = localStorage.getItem('videoPlayAddr');
        // if(addr) {
        //     this.playAddr = addr;
        // }
    },
    beforeDestroy () {

    },
    methods: {
        //序号编号
        controlClick(e, index) {
            var curVal = e.target.value;
            this.webcamList[index].decodeH5Url = curVal;
        },
        confirmEvent() {
            let that = this;
            var reqData = [];
            for(var i = 0; i < this.webcamList.length; i++) {
                var item = {};
                item.deviceSerial = this.webcamList[i].webcamSerial;
                item.decodeH5Url = this.webcamList[i].decodeH5Url;
                reqData[i] = item;
            }
           
            this.$httpApi.updateWebCamListDecodeH5Url(reqData, function(d) {
                // console.log(JSON.stringify(d));
                if(d.status == 200) {
                    that.tipShowFun(that, "设置成功");
                } else {
                    that.tipShowFun(that, "设置失败");
                }
            }, function(xhr) {
                console.log(xhr.responseText);
                that.tipShowFun(that, "设置异常");
            });

            // localStorage.setItem('videoPlayAddr', this.playAddr);
            // this.tipShowFun(this, "设置成功");

            // console.log("playAddr=" + this.playAddr);
            
        },
        //消息提示
        tipShowFun(that, txt) {
            that.tipText = txt;
            that.tipdisplay = "block";
            setTimeout(() => {
                that.tipdisplay = "none";
                that.tipText = '';
            }, 1000);
        },
    }
}
</script>

<style lang="scss" scoped>

#changePwd {
    width:350px;
    margin:10px auto;
    margin-top:10px;
    color: #d3d6dd;
    font-size: 18px;
    
    text-align: center;
    display:flex;
    flex-direction:column;
    align-items:center;

    .content-item {
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:center;
    }

    .content-item-blank {
        margin-top:20px;
    }

    .label-blank {
        margin-right:5px;
    }

    .confirmBtn {
        width:100%;
        margin-top:30px;
        padding:15px;
        border:1px solid #257dff;
    }

    input {
        width:850px;
        height:40px;
        padding-left:10px;
        padding-right:10px;
        border: 1px solid #257dff;
        background-color:rgba(0,0,0,0);
        font-size: 20px;
        color:rgb(0, 186, 255);
    }

    .fun-tip {
        // position:absolute;
        // left:40%;
        // bottom:20px;
        width:200px;
        margin-top:40px;
        padding:12px 20px;
        background-color: rgba(19, 25, 47, 0.6);
        border:2px solid rgb(46, 96, 153);
        border-radius:10px;
    }
}

</style>
